import { GetTimesheetsResponseItem } from '@sit/client-shared';
import { createContext } from 'react';
import { TimesheetModalType } from './timesheet-modal-type';

export type TimesheetModalState =
  | {
      type: TimesheetModalType.NEW | TimesheetModalType.CLOSED;
    }
  | {
      type: TimesheetModalType.DUPLICATE;
      timesheetId: string;
    }
  | {
      type: TimesheetModalType.BULK_DELETE;
      timesheets: TimesheetBulkDeleteItem[];
    };

export type TimesheetBulkDeleteItem = Pick<GetTimesheetsResponseItem, 'id' | 'id' | 'description'> & {
  startDate: Date | string;
  endDate: Date | string;
};

export const TimesheetModalsContext = createContext<{
  state: TimesheetModalState;
  openNewTimesheetModal: () => void;
  openDuplicateTimesheetModal: (timesheetId: string) => void;
  openBulkDeleteTimesheetsModal: (timesheets: TimesheetBulkDeleteItem[]) => void;
  closeModal: () => void;
}>({
  state: { type: TimesheetModalType.CLOSED },
  openNewTimesheetModal: () => {},
  openDuplicateTimesheetModal: () => {},
  openBulkDeleteTimesheetsModal: () => {},
  closeModal: () => {},
});
